import { css } from 'linaria';

export const creditSection = css`
  && {
    padding: 80px 0;
    margin-bottom: 0;
    background-color: var(--background-secondary);

    @media (--only-tablet) {
      padding: 64px 0;
    }

    @media (--only-mobile) {
      padding: 40px 0;
    }
  }
`;

export const creditSectionWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (--to-desktop) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    row-gap: 32px;
  }

  @media (--only-mobile) {
    row-gap: 16px;
  }
`;

export const creditSectionContent = css`
  @media (--only-desktop) {
    width: 261px;
  }

  @media (--only-mobile) {
    width: 261px;
  }
`;

export const creditSectionTitle = css`
  && {
    margin-bottom: 8px;
  }
`;

export const creditSectionText = css`
  && {
    @media (--from-tablet) {
      line-height: 28px;
    }
  }
`;

export const creditSectionImgWrapper = css`
  display: flex;
  column-gap: 58px;

  @media (--only-tablet) {
    column-gap: 88px;
  }

  @media (--only-mobile) {
    justify-content: space-between;
    width: 100%;
    padding: 18px 0;
    column-gap: 0;
  }
`;

export const creditSectionImgFirst = css`
  display: block;
  width: 232px;
  height: 99px;

  @media (--only-tablet) {
    width: 226px;
  }

  @media (--only-mobile) {
    width: 35.31vw;
    height: auto;
  }
`;

export const creditSectionImgSecond = css`
  display: block;
  width: 354px;
  height: 99px;

  @media (--to-desktop) {
    width: 346px;
  }

  @media (--only-mobile) {
    width: 45.31vw;
    height: auto;
  }
`;
